'use client'

import { useRouter } from 'next/navigation'

import { IconButton } from 'shared/ui/iconButton'

import { ROUTER_PATHS } from 'shared/config/routerPath/RouterPath'
import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './HeaderBack.module.scss'

interface HeaderBackProps {
  backNavigation?: () => void
}

export function HeaderBack({ backNavigation }: HeaderBackProps) {
  const router = useRouter()

  const handleBackClick = () => {
    if (backNavigation) {
      backNavigation()
    } else {
      router.push(ROUTER_PATHS.home)
    }
  }

  return (
    <IconButton
      buttonType="squired"
      buttonColor="extra"
      iconName="chevronLeft"
      iconColor={globalStyles['--icon-secondary']}
      iconSize="medium"
      className={styles.button}
      onClick={handleBackClick}
    />
  )
}
